import { FC } from 'react';
import { Feature } from '../../services/backstage/Feature';
import { EmployeePresenceSection } from './present/EmployeePresenceSection';
import { ResourcesCostSummarySection } from './summary/ResourcesCostSummarySection';
import { UnverifiedClocksSection } from './unverifiedClocks/UnverifiedClocksSection';

interface HomeContentsManagersProps {}

export const HomeContentsManagers: FC<HomeContentsManagersProps> = () => {
  return (
    <div className="flex flex-col gap-5">
      <Feature name="clockIn">
        <EmployeePresenceSection />
      </Feature>
      <Feature name="pay">
        <ResourcesCostSummarySection />
      </Feature>
      <Feature name="clockIn">
        <UnverifiedClocksSection />
      </Feature>
    </div>
  );
};
